
import {
  Box,
  Flex,
  HStack,
  IconButton,
  useDisclosure,
  useColorModeValue,
  Stack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Button,
  Image,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';

const Links = ['Home', 'About', 'Services', 'Contact'];

const NavLink = ({ children, onClick  }) => (
  <Button
    variant="ghost"
    _hover={{ bg: useColorModeValue('gray.200', 'gray.700') }}
    px={3}
    onClick={onClick}
  >
    {children}
  </Button>
);

const Navbar = () => {
  
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  return (

    <Box position="fixed"
    top="0"
    left="0"
    right="0"
    zIndex="1000" bg={useColorModeValue('white', 'gray.800')} px={4} boxShadow='md'>
      <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
      <Image src="/assets/images/logo.png" alt="MyLogo" height="100px" />

        {/* Desktop Links */}
        <HStack spacing={8} alignItems={'center'} display={{ base: 'none', md: 'flex' }}>
          {Links.map((link) => (
            <NavLink key={link}>{link}</NavLink>
          ))}
        </HStack>

        {/* Mobile Menu Button */}
        <IconButton
          size={'md'}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label={'Open Menu'}
          display={{ md: 'none' }}
          onClick={isOpen ? onClose : onOpen}
        />
      </Flex>

      {/* Mobile Drawer */}
      <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
          <DrawerBody>
            <Stack spacing={4}>
              {Links.map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
              
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  )
}

export default Navbar
